import { CSSObject } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import { MantineThemeComponent } from '../../types';

const TooltipDefaultConfig: MantineThemeComponent = {
	defaultProps: {
		arrowSize: 5,
		withArrow: true,
		arrowPosition: 'center',
		color: 'var(--color-bg-top)',
		position: 'bottom',
		p: '8px',
		offset: 4
	},
	styles: () => ( {
		tooltip: {

			...( textVariants[ 'caption-regular' ] as CSSObject ),
			color: 'var(--color-text-inverted)'
		}
	} )
};

export default TooltipDefaultConfig;
